var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(this.$store.state.moduleSessionList, function(ms, index) {
        return _c(
          "b-card",
          {
            key: index,
            staticClass: "module-session-list-card",
            attrs: {
              "header-border-variant": "secondary",
              "border-variant": "dark"
            }
          },
          [
            _c("template", { slot: "header" }, [
              _c("h2", [
                _vm._v(_vm._s(ms.moduleName) + " - " + _vm._s(ms.language))
              ])
            ]),
            _c("h3", [
              _c("span", { staticClass: "align-left" }, [
                _vm._v(
                  "Time: " +
                    _vm._s(
                      _vm
                        .$moment(ms.sessionTimeRaw, "DD-MM-YYYY HH:mm")
                        .format("DD-MM-YYYY HH:mm")
                    ) +
                    "  - Room: " +
                    _vm._s(ms.roomId)
                )
              ]),
              _c("span", [_vm._v("   ")]),
              ms.seatTotal - ms.seatTaken < 5
                ? _c("span", { staticClass: "align-right danger-seat-left" }, [
                    _vm._v(
                      _vm._s(
                        ms.seatTotal - ms.seatTaken <= 0
                          ? "Fully Booked"
                          : "Seat Available: " + (ms.seatTotal - ms.seatTaken)
                      )
                    )
                  ])
                : ms.seatTotal - ms.seatTaken < 15
                  ? _c(
                      "span",
                      { staticClass: "align-right warning-seat-left" },
                      [
                        _vm._v(
                          "Seat Available: " +
                            _vm._s(ms.seatTotal - ms.seatTaken)
                        )
                      ]
                    )
                  : _c(
                      "span",
                      { staticClass: "align-right success-seat-left" },
                      [
                        _vm._v(
                          "Seat Available: " +
                            _vm._s(ms.seatTotal - ms.seatTaken)
                        )
                      ]
                    ),
              _c("span", { staticClass: "align-right" }, [
                _vm._v(" - Seat Taken: " + _vm._s(ms.seatTaken))
              ])
            ]),
            _c("p", { staticClass: "card-text" }, [
              _vm._v("\n        Language: " + _vm._s(ms.language) + " "),
              _c("br"),
              _vm._v("\n        Trainer: " + _vm._s(ms.trainerName) + " "),
              _c("br"),
              _vm._v("\n        Total Seat: " + _vm._s(ms.seatTotal) + " "),
              _c("br"),
              _vm._v(
                "\n        Created By: " + _vm._s(ms.createdBy) + "\n      "
              )
            ]),
            _c(
              "b-row",
              { attrs: { "align-h": "start" } },
              [
                _c(
                  "b-col",
                  { attrs: { sm: "1" } },
                  [
                    ms.seatTotal - ms.seatTaken > 0
                      ? _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "success",
                              to: { path: "mainPage/" + ms.id }
                            }
                          },
                          [_vm._v("Book")]
                        )
                      : ms.seatTotal - ms.seatTaken > 0 && _vm.isAdmin
                        ? _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "success",
                                to: { path: "mainPage/" + ms.id }
                              }
                            },
                            [_vm._v("Book")]
                          )
                        : _c(
                            "b-button",
                            { attrs: { disabled: "", variant: "success" } },
                            [_vm._v("Book")]
                          )
                  ],
                  1
                ),
                _vm.isAdmin
                  ? _c(
                      "b-col",
                      { attrs: { sm: "4" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn-admin",
                            attrs: { variant: "warning", size: "sm" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.popeditMsModal(ms, $event.target)
                              }
                            }
                          },
                          [_vm._v("\n            Edit\n          ")]
                        ),
                        _c(
                          "b-button",
                          {
                            staticClass: "btn-admin",
                            attrs: { variant: "danger", size: "sm" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.removeModuleSession(ms, $event.target)
                              }
                            }
                          },
                          [_vm._v("\n            Remove\n          ")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          2
        )
      }),
      _c(
        "b-modal",
        {
          attrs: {
            id: "editMsModal",
            size: "lg",
            title: "Editting Module Session"
          },
          on: { hide: _vm.emitRefreshEvent }
        },
        [
          _c("EditMsModalPanel", {
            on: { updateModuleSessionInfo: _vm.updateModuleSessionInfo }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c398cbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c398cbc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/mainPage/ModuleSessionList.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7c398cbc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/mainPage/ModuleSessionList.vue
// module chunks = 6